import { GoToChannel } from '@/_elements/Links';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { externalCalendarEventApi } from '@/_services/api/calendarIntegration/externalCalendarEvents';
import { buildEventUrl } from '@/components/Admin/Tasks/EventComponents/utils';
import React, { Fragment, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaRegCalendarAlt, FaExternalLinkAlt } from 'react-icons/fa';
import { VscLoading } from 'react-icons/vsc';

const CopiedActivityLibraryEventsModal = ({ externalCalendarEvent }) => {
    const [showModal, setShowModal] = useState(false);
    const [results, setResults] = useState([]);
    const [isBusy, setIsBusy] = useState(false);

    const handleShow = async () => {
        setShowModal(true);
        try {
            setIsBusy(true);
            const { results = [] } = await externalCalendarEventApi.getCopiedTasks(externalCalendarEvent._id);
            setResults(results);
        } catch (err) {
            console.error('Error:', err);
        } finally {
            setIsBusy(false);
        }
    };

    const handleClose = () => {
        setShowModal(false);
        setResults([]);
    };
    const onLinkClick = (taskData) => {
        const url = buildEventUrl(taskData);
        window.open(url, '_blank');
    };

    return (
        <Fragment>
            <BootstrapToolTip
                text={'View Copied Activity Library Event List'}
                cssStyles={'top:-70% !important; min-width: fit-content !important;'}
            >
                <FaRegCalendarAlt onClick={() => handleShow()} className="icon view" />
            </BootstrapToolTip>

            <Modal show={showModal} onHide={handleClose} size="md" centered>
                <div style={{ border: '4px solid #ccc' }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Copied Channel "Activity Library Events" for:
                            <br />
                            <strong>{externalCalendarEvent?.title}</strong>
                            <br />
                            <p>
                                This event has been copied <strong>{results.length}</strong> times
                            </p>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {isBusy ? (
                            <VscLoading className="spin" />
                        ) : (
                            <Fragment>
                                {results.length === 0 ? (
                                    <p>No results found</p>
                                ) : (
                                    <ul className="list-unstyled mb-4 ml-3">
                                        {results.map((item, index) => (
                                            <li key={item._id} className="py-3 border-bottom">
                                                <span className="mr-2">{index + 1}.</span>
                                                <strong>{item.title}</strong>
                                                <span>
                                                    <FaExternalLinkAlt
                                                        color="#50aeb0"
                                                        className="ml-2 pointer"
                                                        onClick={() => {
                                                            onLinkClick(item);
                                                        }}
                                                    />
                                                </span>
                                                <br />
                                                <div className="ml-4 d-flex">
                                                    <div>Channel:</div>
                                                    <div className="ml-2">
                                                        <GoToChannel channel={item?.chatroomData || {}} />
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </Fragment>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={handleClose}>
                            Close
                        </button>
                    </Modal.Footer>
                </div>
            </Modal>
        </Fragment>
    );
};

export default CopiedActivityLibraryEventsModal;
